import {
    Component,
    Inject,
    ChangeDetectionStrategy,
    HostListener,
    ElementRef,
    ViewChild,
    AfterViewInit,
    ChangeDetectorRef,
    Renderer2,
    OnInit,
    ViewContainerRef,
    TemplateRef,
    Injector,
    ComponentRef
} from '@angular/core';
import { ADS_BANNER } from '@app/ads/tokens';
import { DOCUMENT } from '@angular/common';
import { AdsService } from '../services/ads.service';
import * as Banners from '../components';
import { TgBot } from '@app/core/models/models';
import { Helper } from '@app/core/helper';

@Component({
    selector: 'div.banner-inbody-cont.d52c',
    templateUrl: '../templates/b2-inbody.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class B2InbodyComponent implements AfterViewInit {
    @ViewChild('xBtnTmp') xBtnTmp!: TemplateRef<any>;
    @ViewChild('cont', { read: ViewContainerRef }) cont!: ViewContainerRef;
    nodes: Array<ComponentRef<any>> = [];
    currIndBan: number = 0;
    VHight: number = this.bot.WebApp.viewportStableHeight ? this.bot.WebApp.viewportStableHeight : 496;
    private _lastTop!: number;
    private _switchTime!: number;

    constructor(
        @Inject(ADS_BANNER)
        public bans: any,
        @Inject(DOCUMENT)
        public doc: any,
        private el: ElementRef,
        private cdr: ChangeDetectorRef,
        private ren: Renderer2,
        @Inject('SESSIONSTORAGE')
        private sss: any,
        @Inject('TGBOT')
        private bot: TgBot
    ) { }

    @HostListener('window:scroll')
    scr(event: any): void {
        this.nodes?.length ? this.observeInBody() : null;
    }

    ngAfterViewInit(): void {
        if (this.isHideBan) {
            this.doc.body.classList.add('ban-hid');
            return;
        }
        this.cont.clear();
        this.bans = Helper.shuffle(this.bans);
        this.bans.map((b: any) => {
            const clsNm = 'B' + b.t + 'Component';
            const injector: Injector = Injector.create({
                providers: [
                    {
                        provide: ADS_BANNER,
                        useValue: b,
                    },
                ],
            });
            const cls: any = Banners[clsNm as keyof typeof Banners];
            const cr = this.cont.createComponent(cls, { injector });
            this.nodes.push(cr);
        });
        if (this.nodes.length) {
            this.cont.createEmbeddedView(this.xBtnTmp);
            this.setVisComp(this.nodes[0], true);
            this.cdr.detectChanges();
        }
    }

    trackById(itm: any) {
        return itm.id;
    }

    setVisComp(comRef: ComponentRef<any>, vis: boolean): void {
        const el = comRef.location.nativeElement;
        if (vis) {
            this.ren.setStyle(el, 'z-index', 5);
            this.ren.addClass(el, 'visible');

            this._lastTop = this.doc.documentElement.scrollTop;
            this._switchTime = Date.now();
        } else {
            this.ren.setStyle(el, 'z-index', 0);
            this.ren.removeClass(el, 'visible');
        }
    }

    close() {
        this.cont.clear();
        this.isHideBan = true;
        this.doc.body.classList.add('ban-hid')
        this.cdr.detectChanges();
    }

    observeInBody() {
        if (this.nodes?.length > 0) {
            let ind = this.getCurrIndex();

            if (ind >= 0 && ind < this.nodes.length && ind !== this.currIndBan) {
                this.setVisComp(this.nodes[this.currIndBan], false);
                this.setVisComp(this.nodes[ind], true);
                this.currIndBan = ind;
            }
        }
    }

    getCurrIndex() {
        if (Date.now() - this._switchTime < 2000) {
            return this.currIndBan;
        }
        const curTop = this.doc.documentElement.scrollTop;
        const diff = curTop - this._lastTop;
        if (Math.abs(diff) < this.VHight) {
            return this.currIndBan;
        }
        const dir = diff < 0? -1 : 1;
        const ind = this.currIndBan + dir;
        if (ind < 0) {
            return this.nodes.length + ind;
        }
        return ind % this.nodes?.length;
    }

    private get isHideBan() {
        let isHideBan = this.sss.getItem('isHideBanner');
        return !!isHideBan
    }

    private set isHideBan(val: boolean) {
        this.sss.setItem('isHideBanner', val);
    }
}
